const globalMutableStore = {
  zeroDate: null,
  activeId: null,
  scrollDirections: [],
};

export default globalMutableStore;
